import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ShareMoveConfig } from './share-move.config';
import { ShareMoveAnnouncementModule } from './announcement';
import { ShareMoveCustomizeModule } from './customize';
import { ShareMovePreviewModule } from './preview';
import { ShareMovePublicModule } from './public';

export const ShareMoveStepModule = angular
  .module('app.steps.share-move', [
    uiRouter,
    ShareMoveAnnouncementModule.name,
    ShareMoveCustomizeModule.name,
    ShareMovePreviewModule.name,
    ShareMovePublicModule.name,
  ])
  .config(ShareMoveConfig);
